import { composeIO } from 'react-compose-io'
import { controleComissaoIO } from './ControleComissao.IO'
import { ControleComissaoView } from './ControleComissao.View'

export const ControleComissao = composeIO(ControleComissaoView, controleComissaoIO)
